"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyDownHandler = void 0;
var react_1 = require("react");
// Hook fires callback when keyboard key is pressed
var useKeyDownHandler = function (key, callback) {
    react_1.useEffect(function () {
        var handleKeyPressed = function (event) {
            if (event.key === key) {
                callback();
            }
        };
        // Bind the event listener
        document.addEventListener("keydown", handleKeyPressed, true);
        return function () {
            // Unbind the event listener on clean up
            document.removeEventListener("keydown", handleKeyPressed, true);
        };
    }, [key, callback]);
};
exports.useKeyDownHandler = useKeyDownHandler;
